import { EventApi } from 'api'
import { withErrorBoundary, connected, SearchBar } from 'shared'
import { ModelGrid, TopLevelPage } from 'ui'
import CommunityDatePicker from './CommunityDatePicker'
import PropTypes from 'prop-types'
import useForceUpdate from 'hooks/useForceUpdate'
import { useRef, useState } from 'react'

const CommunityCalendar = ({ match }) => {
  const params = EventApi.paramsFor('all')
  const queryRef = useRef(EventApi.paramsFor('all').q)

  const [state, setState] = useState({
    startDate: (params.from || params.date) && moment(params.from || params.date),
    endDate: params.till && moment(params.till)
  })

  const forceUpdate = useForceUpdate()
  const queryDidChange = query => { queryRef.current = query }
  const queryWouldSubmit = () => { forceUpdate() }
  const datesDidChange = dates => { setState(dates) }

  let { startDate, endDate } = state
  let dateParams = startDate && !endDate ? { date: startDate } : { from: startDate, till: endDate }
  let models = EventApi.kick('all', { q: queryRef.current, ...dateParams })

  return (
    <TopLevelPage className="Community" modelId={match.params.id} base="/community">
      <div className="row">
        <div className="col-sm-6 col-lg-4 col-xl-3">
          <SearchBar onChange={queryDidChange} onSubmit={queryWouldSubmit} initialQuery={queryRef.current} />
        </div>
      </div>
      <div className="row">
        <div className="col-md-9 order-2 order-md-1">
          <ModelGrid models={models} base={'community'} />
        </div>
        <div className="col-md-3 order-1 order-md-2">
          <div className="list-calendar-panel">
            <CommunityDatePicker startDate={startDate} endDate={endDate} onChange={datesDidChange} />
          </div>
        </div>
      </div>
    </TopLevelPage>
  )
}

CommunityCalendar.propTypes = {
  match: PropTypes.object
}

export default withErrorBoundary(connected(CommunityCalendar))
